<template>
  <div class="transaction">
    <BaseSvgIcon
      :name="value ? 'success2' : 'error2'"
      :style="{ width: '19px', height: '19px' }"
    />
  </div>
</template>

<script>
import { BaseSvgIcon } from "@/shared/ui";
import { shorten } from "@/shared/utils/format";
import "@/assets/icons/SVG/error2.svg";
import "@/assets/icons/SVG/success2.svg";
export default {
  name: "Hash",
  components: { BaseSvgIcon },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
  },

  methods: { shorten },
};
</script>

<style lang="scss" scoped>
.transaction {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
}
</style>
